"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var theme = require("../theme.scss");
var classnames = require("classnames");
var moment = require("moment");
var mobx_react_1 = require("mobx-react");
var Notification = /** @class */ (function (_super) {
    tslib_1.__extends(Notification, _super);
    function Notification() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onNotificationClick = function () {
            var _a = _this.props, notification = _a.notification, onSelectItem = _a.onSelectItem;
            onSelectItem(notification._id);
        };
        return _this;
    }
    Notification.prototype.render = function () {
        var _a, _b, _c, _d;
        var _e = this.props, notification = _e.notification, selectedItemId = _e.selectedItemId;
        var isSelected = selectedItemId === notification._id;
        return (React.createElement("div", { className: classnames(theme.notification, (_a = {}, _a[theme.selected] = isSelected, _a)), onClick: this.onNotificationClick },
            React.createElement("div", { className: theme.left },
                React.createElement("div", { className: classnames(theme.dot, (_b = {}, _b[theme.seen] = notification.seen, _b)) }),
                React.createElement("div", { className: classnames(theme.text, (_c = {}, _c[theme.seen] = notification.seen, _c)) },
                    React.createElement("div", { className: theme.subjectContainer },
                        React.createElement("div", { className: theme.subject }, notification.subject)),
                    React.createElement("div", { className: theme.notificationType }, notification.app || "Vidazoo"),
                    React.createElement("div", { className: classnames(theme.date, (_d = {}, _d[theme.seen] = notification.seen, _d)) }, moment(notification.created).fromNow())))));
    };
    Notification = tslib_1.__decorate([
        mobx_react_1.observer
    ], Notification);
    return Notification;
}(React.Component));
exports.default = Notification;
